export enum Types {
	CONSULTA_ATENDIMENTO_PJ_REQUEST = '@procon/CONSULTA_ATENDIMENTO_PJ_REQUEST',
	CONSULTA_ATENDIMENTO_PJ_SUCCESS = '@procon/CONSULTA_ATENDIMENTO_PJ_SUCCESS',
	CONSULTA_ATENDIMENTO_PJ_FAILURE = '@procon/CONSULTA_ATENDIMENTO_PJ_FAILURE',
	CONSULTA_ATENDIMENTO_PJ_CLEAR = '@procon/CONSULTA_ATENDIMENTO_PJ_CLEAR',
}

export interface ConsultaAtendimentoPj {
	status: null | number;
	data: null | ConsultaAtendimentoPjData;
}

export interface ConsultaAtendimentoPjData {
	atendimentoId: string;
	area: string;
	assunto: string;
	dataDaSolicitacao: string;
	dataDaContratacao: string;
	dataDaOcorrenciaOuServico: string;
	dataDeCancelamentoDesistenciaOuNegativa: string;
	descricaoDoProblema: string;
	detalhesDoServicoOuProduto: string;
	formaDeAquisicao: string;
	formaDeDevolucao: string;
	detalhesDaReclamacao: string;
	formaDePagamento: string;
	grupoDeProblema: string;
	nomeDoServicoOuProduto: string;
	numeroDoDocumentoDeCompra: string;
	numeroDoProtocolo: string;
	pedidoDoConsumidor: string;
	problema: string;
	procureiOFornecedorParaSolucionarAQuestao: string;
	descricaoDoPrimeiroContatoComFornecedor: string;
	protocolo: string;
	prazoDeAtendimento: string;
	localizacaoAtual: string;
	participacaoEmAudiencia: string;
	razaoDoStatus: string;
	respostaDoConsumidor: string;
	respostaDoFornecedor: string;
	ultimaAtualizacao: string;
	anexos: string[];
	rgDoResponsavelOuProcurador: string;
	nomeDoResponsavelOuProcurador: string;
	cpfDoProcuradorOuResponsavel: string;
	tipoDeAtendimento: string;
	tipoDeContratacao: string;
	tipoDoConsumidor: string;
	tipoDoDocumentoDeCompra: string;
	valorDaCompra: number;
	consumidorPj?: {
		cpf?: string;
		cnpj?: string;
		email: string;
		razaoSocial: string;
		telefone: string;
		endereco: {
			bairro: string;
			cep: string;
			complemento: string;
			estado: string;
			logradouro: string;
			municipio: string;
			numero: string;
		};
	};
	fornecedor: {
		cnpj: string;
		cpf: string;
		email: string;
		endereco: {
			bairro: string;
			cep: string;
			complemento: string;
			estado: string;
			logradouro: string;
			municipio: string;
			municipioId: string;
			numero: string;
			cidade: string;
		};
		telefone: string;
		razaoSocial: string;
		nomeFantasia: string;
		website: string;
	};
	tipoDoFornecedor: string;
	idDoBalcaoUnico: number;
	compraAgencia: string;
	compraBancoEmissor: string;
	compraBandeiraDoCartao: string;
	compraChavePix: string;
	compraConta: string;
	compraIntermediadoraDePagamento: string;
	compraNumeroDoCartao: string;
	compraTipoDeChavePix: 0;
	devolucaoAgencia: string;
	devolucaoBancoEmissorDoCartao: string;
	devolucaoBandeiraDoCartao: string;
	devolucaoChavePix: string;
	devolucaoConta: string;
	devolucaoNomeDoBanco: string;
	devolucaoNumeroDeParcelas: 0;
	devolucaoNumeroDoCartao: string;
	devolucaoTipoDeChavePix: 0;
	devolucaoValorDaParcela: 0;
	interacao: string;
	interacaoValor: number;
}

export interface ConsultaAtendimentoPjRequest {
	atendimentoId: string;
	protocolo: string;
	numeroFa?: string;
}
